import { getOpenBets } from '@/utils/api';
import i18n from '@/utils/i18n';
import take from 'lodash/take';
import { formatOpenBetsData } from '@/views/history/history-utils';
import { LoginTypes } from '@/utils/enums';

const state = {
  openBets: [],
  openBetsStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const getters = {
  openBetsSummary: state => take(state.openBets, 10),
  openBetsFields: _ => [
    {
      key: 'PlacedDate',
      label: i18n.t('Placed'),
      _searchable: true,
      _sortable: true,
      thStyle: { width: '170px' },
      _sortDirection: 'desc',
    },
    {
      key: 'TicketNumber',
      label: i18n.t('BetSlip.Bet Ticket'),
      _searchable: true,
      _sortable: true,
    },
    {
      key: 'CompleteDescription',
      label: i18n.t('Type'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'OriginalRiskAmount',
      label: i18n.t('Risk'),
      _searchable: true,
      _sortable: true,
    },
    {
      key: 'OriginalWinAmount',
      label: i18n.t('Win'),
      _searchable: true,
      _sortable: true,
    },
  ],
};

const mutations = {
  setOpenBets(state, data) {
    state.openBets = data;
  },
  setOpenBetsStatus(state, row) {
    state.openBetsStatus = {
      ...state.openBetsStatus,
      ...row,
    };
  },
};

const actions = {
  tryGetOpenBets({ commit, rootGetters, rootState }) {
    if (rootState.player.loginType !== LoginTypes.Player) return;
    commit('setOpenBetsStatus', {
      loading: true,
      success: false,
      error: false,
    });
    getOpenBets(rootState.settings.selectedOddType).then(r => {
      if (r.data.IsSuccess) {
        commit('setOpenBetsStatus', { error: false, success: true });
        const currencySymbol = rootGetters['player/currencySymbol'];
        commit('setOpenBets', formatOpenBetsData(r.data.Data, currencySymbol));
      } else {
        commit('setOpenBetsStatus', { error: true, success: false });
      }
      commit('setOpenBetsStatus', { loading: false });
    });
  },
};

export const openBetsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
